(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-product-template"]) return;
  try {
    

(() => {
  const instances = new WeakMap();
  let featureRequest;
  const loadViewer = () => {
    if (window.customElements && customElements.get('model-viewer')) return Promise.resolve();
    if (featureRequest) return featureRequest;
    featureRequest = new Promise((resolve, reject) => {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        reject(new Error('Shopify model viewer loader unavailable'));
        return;
      }
      window.Shopify.loadFeatures([{ name: 'model-viewer', version: '1.12', onLoad: error => {
        if (error) reject(error);
        else resolve();
      }}]);
    });
    return featureRequest;
  };
  const init = root => {
    if (instances.has(root)) return;
    const gallery = root.querySelector('.mrr-product-gallery');
    if (!gallery) return;
    const panels = Array.from(gallery.querySelectorAll('[data-mrr-model-panel]'));
    if (!panels.length) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const timers = new Set();
    let frame;
    const syncLayout = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (!root.isConnected) return;
        if (window.matchMedia('(max-width: 749px)').matches) {
          root.style.setProperty('--mrr-gallery-height', window.scrollY > 50 ? '120px' : '350px');
          root.style.setProperty('--mrr-gallery-offset', `${Math.ceil(gallery.getBoundingClientRect().height) + 24}px`);
        } else {
          root.style.removeProperty('--mrr-gallery-height');
          root.style.removeProperty('--mrr-gallery-offset');
        }
      });
    };
    const photo = gallery.querySelector('.product-featured-img');
    const showPhoto = () => {
      panels.forEach(panel => { panel.hidden = true; });
      gallery.classList.remove('mrr-model-active');
      gallery.querySelectorAll('[data-mrr-model-target]').forEach(button => {
        button.setAttribute('aria-pressed', 'false');
        button.classList.remove('active-thumb');
      });
      if (photo) gallery.querySelectorAll('a.product-single__thumbnail').forEach(link => {
        link.classList.toggle('active-thumb', link.getAttribute('href') === photo.getAttribute('src'));
      });
      syncLayout();
    };
    const hydrate = panel => {
      const template = panel.querySelector('[data-mrr-model-template]');
      if (!template) return;
      const fragment = template.content.cloneNode(true);
      const viewer = fragment.querySelector('model-viewer');
      const stage = panel.querySelector('.mrr-gallery-model__stage');
      const errorMessage = panel.querySelector('[data-mrr-model-error]');
      let loaded = false;
      const fail = () => { if (!loaded) { errorMessage.hidden = false; syncLayout(); } };
      const timer = setTimeout(fail, 20000);
      timers.add(timer);
      viewer.addEventListener('load', () => {
        loaded = true;
        clearTimeout(timer);
        timers.delete(timer);
        errorMessage.hidden = true;
        stage.classList.add('mrr-model-loaded');
        syncLayout();
      }, { ...options, once: true });
      viewer.addEventListener('error', fail, options);
      template.replaceWith(fragment);
      loadViewer().catch(fail);
    };
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-mrr-model-target]');
      if (button && gallery.contains(button)) {
        const panel = panels.find(item => item.id === button.dataset.mrrModelTarget);
        if (!panel) return;
        event.preventDefault();
        event.stopPropagation();
        panels.forEach(item => { item.hidden = item !== panel; });
        gallery.classList.add('mrr-model-active');
        gallery.querySelectorAll('.product-single__thumbnail').forEach(item => {
          item.classList.toggle('active-thumb', item === button);
          if (item.hasAttribute('data-mrr-model-target')) item.setAttribute('aria-pressed', String(item === button));
        });
        hydrate(panel);
        syncLayout();
      } else if (event.target.closest('a.product-single__thumbnail')) {
        showPhoto();
      }
    }, { ...options, capture: true });
    root.addEventListener('change', event => {
      if (event.target.matches('.single-option-selector, .product_options input, .product-form__variants')) showPhoto();
    }, { ...options, capture: true });
    const imageObserver = new MutationObserver(showPhoto);
    if (photo) imageObserver.observe(photo, { attributes: true, attributeFilter: ['src'] });
    const sizeObserver = new ResizeObserver(syncLayout);
    sizeObserver.observe(gallery);
    window.addEventListener('scroll', syncLayout, { ...options, passive: true });
    window.addEventListener('resize', syncLayout, options);
    instances.set(root, () => {
      controller.abort();
      imageObserver.disconnect();
      sizeObserver.disconnect();
      cancelAnimationFrame(frame);
      timers.forEach(clearTimeout);
      instances.delete(root);
    });
    syncLayout();
  };
  const start = () => document.querySelectorAll('[data-mrr-gallery-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-mrr-gallery-root]').forEach(root => {
      const cleanup = instances.get(root);
      if (cleanup) cleanup();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
